import { render } from "./EditClass.vue?vue&type=template&id=36ecf01c"
import script from "./EditClass.vue?vue&type=script&lang=js"
export * from "./EditClass.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__